import { darkTheme } from "amazon-chime-sdk-component-library-react"
import { DeviceType } from "amazon-chime-sdk-component-library-react/lib/types"
import branding from "../../../branding/branding"
import { useDeviceController } from "../../context/DeviceController"
import { DeviceSelect, SettingsLabel } from "../Settings/Settings.styled"

function MicSelection() {
    const { getCurrentAudioInputDevice, setCurrentAudioInputDevice, getAudioInputDevices } = useDeviceController()
    return (
        <>
            <SettingsLabel>{branding.audioVideoSettings.audioInputLabel}</SettingsLabel>
            <DeviceSelect
                options={getAudioInputDevices()}
                isMulti={false}
                isSearchable={false}
                isClearable={false}
                theme={darkTheme}
                value={getCurrentAudioInputDevice()?.deviceId}
                placeholder={getCurrentAudioInputDevice()?.label}
                onChange={async (device: DeviceType) => {
                    setCurrentAudioInputDevice(device.deviceId, device.label)
                }}
            />
        </>
    )
}

export default MicSelection
